@if (result) {
  <div class="company-search-detail-modal" data-cy="CompanySearch_Modal">
    <div class="detail-row">
      <span class="detail-label">{{ 'MODAL_CONTENTS.COMPANY_SEARCH_DETAIL.NAME' | translate }}</span>
      <span class="detail-value" data-cy="CompanySearch_Modal_Name">{{ result.name }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">{{ 'MODAL_CONTENTS.COMPANY_SEARCH_DETAIL.REG_NUMBER' | translate }}</span>
      <span class="detail-value" data-cy="CompanySearch_Modal_RegNumber">{{ result.registrationNumber }}</span>
    </div>
    @if (result.vatNumber) {
      <div class="detail-row">
        <span class="detail-label">{{ 'MODAL_CONTENTS.COMPANY_SEARCH_DETAIL.VAT' | translate }}</span>
        <span class="detail-value" data-cy="CompanySearch_Modal_Vat">{{ result.vatNumber }}</span>
      </div>
    }
    @if (dateOfIncorporation) {
      <div class="detail-row">
        <span class="detail-label">{{ 'MODAL_CONTENTS.COMPANY_SEARCH_DETAIL.INCORPORATION_DATE' | translate }}</span>
        <span class="detail-value" data-cy="CompanySearch_Modal_IncorporationDate">{{ dateOfIncorporation }}</span>
      </div>
    }
    @if (result.registeredAddress) {
      <div class="detail-row address">
        <span class="detail-label">{{ 'MODAL_CONTENTS.COMPANY_SEARCH_DETAIL.ADDRESS' | translate }}</span>
        <span class="detail-value" data-cy="CompanySearch_Modal_Address">
          @if (result.registeredAddress.line1) { {{ result.registeredAddress.line1 }}, }
          @if (result.registeredAddress.line2) { {{ result.registeredAddress.line2 }}, }
          @if (result.registeredAddress.city) { {{ result.registeredAddress.city }}, }
          @if (result.registeredAddress.postalCode) { {{ result.registeredAddress.postalCode }}, }
          @if (result.registeredAddress.country) { {{ result.registeredAddress.country }} }
        </span>
      </div>
    }
  </div>
}
